(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockTarifwechsel', {
            require: {
                form: '^form'
            },
            bindings: {
                angebotVm: '=abtAngebotVm'
            },
            templateUrl: 'bloecke/tarifwechsel/blockTarifwechsel.html',
            controller: BlockTarifwechselkController,
            controllerAs: 'tarifwechselVm'
        });

    BlockTarifwechselkController.$inject = [
        '$scope',
        '$modal',
        'moment',
        'lodash',
        'AppConfig',
        'AngebotModel',
        'FormFieldUtilsService',
        'AngebotUtilsService'
    ];
    function BlockTarifwechselkController($scope, $modal, moment, _, AppConfig, AngebotModel, FormFieldUtilsService, AngebotUtilsService) {
        var vm = this,
            angebotModel,
            modalNeuerTarif,
            aktuellerTarif,
            currentDate,
            tarifrechnerTarif = AppConfig.ANGEBOT.tarifkuerzel;

        vm.$onInit = onInit;

        vm.showModal = showModal;

        $scope.$on('asys:tarifwechsel:showModal', function () {
            showModal();
        });

        function activate() {
            angebotModel = AngebotModel.get();
            aktuellerTarif = _.get(angebotModel, 'tarif') || {};
            currentDate = moment().format(AppConfig.API.dateFormat);
            if (_.get(angebotModel.angebot, 'neuerTarifVerfuegbar') === true) {
                if (_.get(angebotModel, 'showTarifWechselModal') !== false) {
                    _.unset(angebotModel, 'showTarifWechselModal');

                    showModal();
                }
            }

            vm.isHinweisVisible = (
                AppConfig.ANGEBOT.disableTarifgenerationHandling !== true &&
                _.get(angebotModel, 'showTarifWechselModal') === false &&
                _.get(angebotModel.angebot, 'neuerTarifVerfuegbar') === true
            );
        }

        function onInit() {
            activate();
        }
        function showModal() {
            FormFieldUtilsService.handlePending(vm.allgemeinForm, 'wechsleTarif', true);

            modalNeuerTarif = $modal.open({
                templateUrl: 'modal/modalNeuerTarif.html',
                windowClass: 'medium',
                controller: 'ModalNeuerTarifController',
                controllerAs: 'modalVm'
            });

            modalNeuerTarif.result.then(function () {
                vm.isHinweisVisible = false;
                _.unset(angebotModel, 'showTarifWechselModal');

                if (!AngebotUtilsService.isTarifauskunftsdatumInTarifgeneration(currentDate, aktuellerTarif)) {
                    return AngebotModel.getTarifgeneration(currentDate).then(function (tarifNeu) {
                        AngebotUtilsService.wechsleTarifgeneration(currentDate, tarifNeu.tarifkuerzel, tarifrechnerTarif);
                    });
                } else {
                    return vm.angebotVm.erstelleNeuesAngebot();
                }
            }).catch(function (error) {
                _.set(angebotModel, 'showTarifWechselModal', false);
                vm.isHinweisVisible = true;
            }).finally(function () {
                FormFieldUtilsService.handlePending(vm.form, 'wechsleTarif', false);
            });
        }
    }

})();
